import React from 'react';
import { DeepPageWithShell } from './DeepPage';
import { usePageMeta } from '../../lib/useMeta';
import { serviceSchema } from '../../lib/schema';

const PATH = '/teen-martial-arts';

const DATA = {
  breadcrumbs: [
    { label: 'Home', href: '/' },
    { label: 'Programs', href: '/#programs' },
    { label: 'Teen Martial Arts' },
  ],
  eyebrow: 'Teen Program',
  h1: 'Teen Martial Arts in Colorado Springs',
  tagline: 'Ages 13\u201317 · Kempo Karate · Self-Defense',
  intro:
    'Our teen program sharpens technique, builds confidence, and teaches real-world self-defense that will serve your teenager for life. Universal Kempo Karate has trained Colorado Springs teens since 1980.',
  heroImage: 'https://customer-assets.emergentagent.com/job_kempo-patch/artifacts/1tz65hu0_3.jpeg',
  heroImageAlt: 'Teen martial arts class at Universal Kempo Karate',
  callouts: [
    { title: 'Technique + Grit', body: 'Pressure-tested drills that build confidence under stress.' },
    { title: 'Leadership Pathway', body: 'Senior teen students become assistants and mentors to younger kids.' },
    { title: 'A Smarter Screen Break', body: 'Two nights a week off the phone, on the mat, moving.' },
  ],
  featureList: [
    'Realistic self-defense scenarios',
    'Striking + grappling fundamentals',
    'Leadership and mentorship pathway',
    'Tournament and demo opportunities (optional)',
    'Fitness, discipline, and goal-setting',
    'Belt-rank progression',
  ],
  sections: [
    {
      eyebrow: 'What Teens Train',
      heading: 'The full Kempo system, taught like it matters.',
      body: [
        'Teen Kempo classes drill the complete toolkit \u2014 strikes, blocks, sweeps, locks, and reality-based self-defense flow. Teens learn how to recognize and de-escalate before anything physical, and what to do if there is no other choice.',
        'This is the age where good training produces lifelong habits. Our teen program is designed to turn interested students into confident, capable martial artists by their 18th birthday.',
      ],
      bullets: [
        'Controlled partner drills and sparring',
        'Grappling and ground-defense basics',
        'Street-aware self-defense scenarios',
        'Weapons familiarization (training weapons)',
        'Kata, form, and traditional study',
      ],
    },
    {
      eyebrow: 'Why It Works',
      heading: 'Confidence that holds under pressure.',
      body: [
        'The teen years are hard. Our mat is a place where effort is rewarded, respect is non-negotiable, and nobody judges where you started. Teens who train consistently gain real self-defense ability, better focus, better posture, and a social group built on effort.',
        'Many of our senior teen students become assistant instructors \u2014 the single best confidence builder we have ever seen.',
      ],
    },
  ],
  ctaCopy: 'Book a Free Teen Trial',
  source: 'page-teen-martial-arts',
};

const TeenMartialArtsPage = () => {
  usePageMeta({
    title: 'Teen Martial Arts in Colorado Springs | Universal Kempo Karate',
    description:
      'Teen martial arts in Colorado Springs for ages 13\u201317. Real-world self-defense, confidence, and discipline through traditional Kempo karate. Free trial classes.',
    path: PATH,
    breadcrumbs: DATA.breadcrumbs,
    schemas: [
      {
        id: 'teen-service-jsonld',
        data: serviceSchema({
          name: 'Teen Martial Arts',
          description: 'Teen Kempo karate and self-defense training for ages 13\u201317.',
          slug: PATH,
          serviceType: 'Martial Arts Instruction',
        }),
      },
    ],
  });
  return <DeepPageWithShell data={DATA} />;
};

export default TeenMartialArtsPage;
